import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { VideoAttributeValue } from '@yoimo/interfaces';

@Component({
  selector: 'app-single-select',
  templateUrl: './single-select.component.html',
  styleUrls: ['./single-select.component.scss'],
})
export class SingleSelectComponent implements OnChanges {
  ddName = '';
  ddOpen = false;
  searchText = '';
  filterList!: ListType[] | undefined;
  isCleared = false;
  @Input() isCreateFlowDropdown = false;
  @Input() assignTicket = false;
  @Input() heading!: string | ListType;
  @Input() list!: ListType[] | VideoAttributeValue[];
  @Input() index!: number;
  @Input() selectedEvent = '';
  @Input() width = '';
  @Input() dropDownName = '';
  @Input() disableDropdown = false;
  @Input() filterDisabled = false;
  @Input() disabled = false;
  @Input() disableSearch = false;
  @Input() disableClose = false;
  @Input() classNames = '';
  // Output bindings, including aliases, should not be named "on", nor prefixed with it (https://angular.io/guide/styleguide#style-05-16)
  @Output() valueChanged = new EventEmitter<ListType>();
  @Output() valueCleared = new EventEmitter<ListType>();
  @Input() enableCustomTooltip = false;
  @Input() customTooltipText = '';
  @Input() customTooltipClass = 'custom-tooltip';

  constructor() {}

  ngOnChanges(): void {
    if (this.disableDropdown) {
      this.ddOpen = false;
      this.ddName = '';
    }
  }

  dropDownDivOpen(dropName: string, input?: HTMLInputElement, isFilterDisabled?: boolean) {
    if (dropName === '' || this.isCleared) {
      this.ddName = '';
      this.ddOpen = false;
      this.resetSearchText();
      input?.blur();
      return;
    }

    if (!this.isCleared) {
      if (!this.ddOpen || this.ddName !== dropName) {
        this.resetSearchText();
      }
      this.ddName = dropName;
      this.ddOpen = true;
    }
  }

  resetSearchText() {
    this.searchText = '';
    this.filterList = undefined;
    this.isCleared = false;
  }

  submitValue(value: ListType) {
    this.selectedEvent = value.key;
    this.valueChanged.emit(value);
    this.resetSearchText();
    if (this.filterDisabled) {
      this.ddName = '';
      this.ddOpen = false;
    }
  }

  filterSearch(name: ListType, searchText: string) {
    return (
      name.key?.toString()?.toLowerCase().indexOf(searchText.toLowerCase()) ==
      -1
    );
  }

  onClear(event: MouseEvent | KeyboardEvent) {
    event.stopPropagation();
    this.isCleared = true;
    this.selectedEvent = '';
    this.valueCleared.emit();
  }

  getFilteredList(): ListType[] {
    
    if (!this.searchText) {
      return this.list as ListType[] || [];
    }
    const search = this.searchText.toLowerCase();
    return (this.list as ListType[]).filter(
      (state) =>
        state.key?.toString()?.toLowerCase().includes(search) ||
        state.value?.toString()?.toLowerCase().includes(search)
    );
  }

getFilteredListForCreateFlow(): ListType[] {
  const values = (this.list as ListType[]) || [];
  const searchLower = this.searchText?.toLowerCase() || '';

  const filtered = searchLower
    ? values.filter((item) => {
        const groupMatch = (item.group || '').toLowerCase().includes(searchLower);
        const keyMatch = (item.key || '').toLowerCase().includes(searchLower);
        const valueMatch = (item.value || '').toLowerCase().includes(searchLower);
        const labelMatch = (item.label || '').toLowerCase().includes(searchLower);
        return groupMatch || keyMatch || valueMatch || labelMatch;
      })
    : values;

  const ungrouped = filtered.filter((item) => item.group === undefined);
  const grouped = filtered.filter((item) => item.group !== undefined);

  const groupMap = new Map<string, ListType[]>();
  for (const item of grouped) {
    const key = item.group as string;
    if (!groupMap.has(key)) {
      groupMap.set(key, []);
    }
    groupMap.get(key)!.push(item);
  }

  const groupedSorted: ListType[] = [];
  Array.from(groupMap.keys())
    .sort((a, b) => a.localeCompare(b))
    .forEach((key) => {
      groupedSorted.push(...groupMap.get(key)!);
    });

  return [...ungrouped, ...groupedSorted];
}

  searchEvents() {
    this.filterList = this.isCreateFlowDropdown
      ? this.getFilteredListForCreateFlow()
      : this.getFilteredList();
  }

  trackByFn(index: number, item: ListType): string {
    return item.value || item.key || index.toString();
  }

  getViewportHeight(): number {
    const itemCount = this.getFilteredList().length;
    const maxHeight = 300;
    const itemHeight = 40;
    return Math.min(itemCount * itemHeight, maxHeight);
  }

  get headingText(): string {
    if (!this.heading) {
      return '';
    }

    return typeof this.heading === 'string'
      ? this.heading
      : this.heading.label;
  }
}

export type ListType = { key: string; value: string; label?: string; group?: string};
